import { missionPartnerProfileFeatureName, MissionPartnerProfileState} from "./mission-partner-profile.reducer";
import { MissionPartner } from "../../sign-up/signup.types";

export function selectMissionPartnerProfile(state: { [missionPartnerProfileFeatureName]: MissionPartnerProfileState }): MissionPartner | undefined {
  return state[missionPartnerProfileFeatureName].entity.data;
}
